import apiFinance from '@/api/finance'
import {has} from 'ramda'

const state = {
  error: null,
  isLoading: false,
  finance: null,
}

export const mutationTypes = {
  getFinanceStart: '[get finance] Get finance start',
  getFinanceSuccess: '[get finance] Get finance success',
  getFinanceFailure: '[get finance] Get finance failure',
}

export const actionTypes = {
  getFinance: '[get finance] Get finance',
}

const mutations = {
  [mutationTypes.getFinanceStart](state) {
    state.isLoading = true
    state.finance = null
    state.error = null
  },

  [mutationTypes.getFinanceSuccess](state, payload) {
    state.finance = payload
    state.isLoading = false
  },

  [mutationTypes.getFinanceFailure](state, error) {
    state.isLoading = false
    state.error = error
  },
}

const actions = {
  [actionTypes.getFinance](context, {id}) {
    context.commit(mutationTypes.getFinanceStart)
    return new Promise((resolve) => {
      apiFinance
        .getFinance(id)
        .then((response) => {
          if (has('message', response)) {
            context.commit(mutationTypes.getFinanceFailure, response.message)
            resolve(response)
          }

          context.commit(mutationTypes.getFinanceSuccess, response)
          resolve(response)
        })
        .catch(() => {
          context.commit(mutationTypes.getFinanceFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
